__turbopack_context__.v({
  "header": "JbAT2W_header",
  "header-fallback": "JbAT2W_header-fallback",
  "header-wrapper": "JbAT2W_header-wrapper",
  "header-wrapper--has-sub-menu": "JbAT2W_header-wrapper--has-sub-menu",
  "header-wrapper--secondary": "JbAT2W_header-wrapper--secondary",
});
